import { useInjection } from 'inversify-react';
import { action, toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationService } from '../annotation.service';
import { IAnnotationsStore } from '../annotations.store';
import { IAnnotationUiStore } from '../annotationUi.store';
import { QuestionsList } from '../components/annotations/QuestionsList';
import { IFreeDrawSegmentationService } from '../freeDrawSegmentation.service';
import { answerQuestion, ImageScopeName } from '../question.model';
import { AnswerQuestionCommand } from '../undoRedoCommands/answerQuestionCommand';
import { IUndoRedoHistory } from '../undoRedoHistory.service';

interface IProps {
  readonly?: boolean;
}

export const QuestionsContainer = observer((props: IProps): ReactElement => {
  const annotationService = useInjection(IAnnotationService.$);
  const freeDrawSegmentationService = useInjection(IFreeDrawSegmentationService.$);
  const uiStore = useInjection(IAnnotationUiStore.$);
  const undoRedoService = useInjection(IUndoRedoHistory.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);

  const handleQuestionAnswered = action((questionId: string, answer: string): void => {
    const question = annotationsStore.currentQuestions.find((x) => x.id === questionId);

    if (question) {
      if (question.scopes.some((x) => x === ImageScopeName)) {
        const questionBeforeChange = toJS(question);
        answerQuestion(question, answer);
        undoRedoService.addCommand(
          new AnswerQuestionCommand(annotationService, annotationsStore, freeDrawSegmentationService, questionBeforeChange, toJS(question))
        );
      } else {
        answerQuestion(question, answer);
      }
    }
  });

  const shouldLock = props.readonly ?? (annotationsStore.image === undefined && !uiStore.isImageLoading);

  return (
    <QuestionsList
      readonly={shouldLock}
      questions={annotationsStore.currentQuestions}
      segmentationId={annotationsStore.selectedSegmentation?.feature.id}
      onAnswered={handleQuestionAnswered}
    />
  );
});
